export class RepairFile {
  constructor(
    technical_id,
    boomerang_id,
    folder_type,
    internal_command_number,

    step,
    status_macro,
    status_detail,
    status_guarantee,

    requestor_account_email,
    requestor_collaborator_fullname,

    lastname,
    email,
    phone_number,
    company,

    network_name,
    network_boomerang_id,

    store_name,
    store_boomerang_id,

    manufacturer_name,
    manufacturer_boomerang_id,
    manufacturer_boomerang_full_support,

    category_name,
    category_boomerang_id,
    sub_category_name,
    sub_category_boomerang_id,

    product_boomerang_id,
    product_name,
    product_picture,

    product_manufacturer_name,
    product_manufacturer_name_ref,
    product_manufacturer_code_ref,

    product_network_code_ref,
    product_manufacturer_id_bdd,
    product_description,
    product_reparable,
    product_folder_workflow,
    product_repair_time,
    product_new_price,
    product_new_price_date,
    product_amount_repair_fund,
    product_returnable,
    product_length,
    product_height,
    product_width,
    product_weight,
    product_repair_end_date,
    product_selling_end_date,
    product_comment,
    product_type,

    product_asbestos_answer,
    product_asbestos_proof_needed,
    product_asbestos_proof_file_path,
    product_asbestos_proof_file_path_aws,

    product_buy_date,
    product_buy_proof_needed,
    product_buy_proof_file_path,
    product_buy_proof_file_path_aws,

    product_guarantee_extension_date,
    product_guarantee_extension_proof_needed,
    product_guarantee_extension_proof_file_path,
    product_guarantee_extension_proof_file_path_aws,

    product_force_support_description,
    product_force_support_proof_needed,
    product_force_support_proof_file_path,
    product_force_support_proof_file_path_aws,

    product_commercial_guarantee,
    product_extension_guarantee,
    product_repair_extension_guarantee,
    product_serial_number,

    takeover_product_status,
    takeover_repairer_total_cost,
    takeover_client_price,
    takeover_transport_cost,
    takeover_additional_cost,
    takeover_client_total_cost,

    takeover_product_replacement_name,
    takeover_product_replacement_boomerang_id,

    takeover_billing_number,

    breakdown_description,
    breakdown_type,
    breakdown_type_boomerang_id,

    repairer_estimate_pricing_type,
    initial_pricing_type,

    package_boomerang_id,
    package_code,
    package_type,
    package_client_price,
    package_repairer_cost_code,
    package_repairer_cost_value,
    package_network_code,
    package_designation,
    package_frns_billing_code,
    package_frns_designation,
    package_discount_rate,
    package_catalog_value,

    packet_weight,
    packet_length,
    packet_height,
    packet_width,
    packet_battery_voltage,
    packet_battery_amperage,
    packet_battery_watt_hour,
    express_check_box,

    initial_customer_code,
    initial_package_additional_repair_cost,
    initial_package_transport_cost,
    initial_package_total_repair_cost,
    initial_package_transport_ref_code,

    initial_transporter_modality,
    initial_transporter_type,
    initial_transporter_name,

    initial_expressist_transporter_id,
    initial_expressist_transporter_connexion_id,
    initial_expressist_transporter_connexion_link_id,

    tracking_number,
    with_collect,

    delivery_address_list,

    breakdown_question_list,

    product_guarantee_list,

    repairer_estimate,

    updated_at,
    created_at,

    business_created_at,
    finalization_date,

    repairer_estimate_last_relaunch_date,
    repairer_estimate_last_relaunch_date_day_count,

    estimate_package_last_relaunch_date,
    estimate_package_last_relaunch_date_day_count,

    business_created_day_count,
    takeover_by_client_date,

    deleted_date,
    deleted_day_count,

    close_date,
    close_day_count,

    leave_and_close_with_reason_date,
    leave_and_close_with_reason_day_count,

    guarantee_extension_boomerang_proof,
    guarantee_extension_boomerang_end_date,
    guarantee_extension_boomerang_id,

    initial_erp_repairer_number,

    with_erp_intern,
    erp_intern_client_id,

    prospect_document_list,
    prospect_picture_list,
    prospect_additional_info,
    prospect_repairer_email_contact,
    prospect_manufacturer_support_number,
    prospect_manufacturer_comment,
    prospect_manufacturer_choice,
    prospect_manufacturer_attachment_filename,
    prospect_manufacturer_attachment_path
  ) {
    this.technical_id = technical_id
    this.boomerang_id = boomerang_id
    this.folder_type = folder_type
    this.internal_command_number = internal_command_number

    this.step = step
    this.status_macro = status_macro
    this.status_detail = status_detail
    this.status_guarantee = status_guarantee

    this.requestor_account_email = requestor_account_email
    this.requestor_collaborator_fullname = requestor_collaborator_fullname

    this.lastname = lastname
    this.email = email
    this.phone_number = phone_number
    this.company = company

    this.network_name = network_name
    this.network_boomerang_id = network_boomerang_id

    this.store_name = store_name
    this.store_boomerang_id = store_boomerang_id

    this.manufacturer_name = manufacturer_name
    this.manufacturer_boomerang_id = manufacturer_boomerang_id
    this.manufacturer_boomerang_full_support = manufacturer_boomerang_full_support

    this.category_name = category_name
    this.category_boomerang_id = category_boomerang_id
    this.sub_category_name = sub_category_name
    this.sub_category_boomerang_id = sub_category_boomerang_id

    this.product_boomerang_id = product_boomerang_id
    this.product_name = product_name
    this.product_picture = product_picture

    this.product_manufacturer_name = product_manufacturer_name
    this.product_manufacturer_name_ref = product_manufacturer_name_ref
    this.product_manufacturer_code_ref = product_manufacturer_code_ref

    this.product_network_code_ref = product_network_code_ref
    this.product_manufacturer_id_bdd = product_manufacturer_id_bdd
    this.product_description = product_description
    this.product_reparable = product_reparable
    this.product_folder_workflow = product_folder_workflow
    this.product_repair_time = product_repair_time
    this.product_new_price = product_new_price
    this.product_new_price_date = product_new_price_date
    this.product_amount_repair_fund = product_amount_repair_fund
    this.product_returnable = product_returnable
    this.product_length = product_length
    this.product_height = product_height
    this.product_width = product_width
    this.product_weight = product_weight
    this.product_repair_end_date = product_repair_end_date
    this.product_selling_end_date = product_selling_end_date
    this.product_comment = product_comment
    this.product_type = product_type

    this.product_asbestos_answer = product_asbestos_answer
    this.product_asbestos_proof_needed = product_asbestos_proof_needed
    this.product_asbestos_proof_file_path = product_asbestos_proof_file_path
    this.product_asbestos_proof_file_path_aws = product_asbestos_proof_file_path_aws

    this.product_buy_date = product_buy_date
    this.product_buy_proof_needed = product_buy_proof_needed
    this.product_buy_proof_file_path = product_buy_proof_file_path
    this.product_buy_proof_file_path_aws = product_buy_proof_file_path_aws

    this.product_guarantee_extension_date = product_guarantee_extension_date
    this.product_guarantee_extension_proof_needed = product_guarantee_extension_proof_needed
    this.product_guarantee_extension_proof_file_path = product_guarantee_extension_proof_file_path
    this.product_guarantee_extension_proof_file_path_aws = product_guarantee_extension_proof_file_path_aws

    this.product_force_support_description = product_force_support_description
    this.product_force_support_proof_needed = product_force_support_proof_needed
    this.product_force_support_proof_file_path = product_force_support_proof_file_path
    this.product_force_support_proof_file_path_aws = product_force_support_proof_file_path_aws

    this.product_commercial_guarantee = product_commercial_guarantee
    this.product_extension_guarantee = product_extension_guarantee
    this.product_repair_extension_guarantee = product_repair_extension_guarantee
    this.product_serial_number = product_serial_number

    this.takeover_product_status = takeover_product_status
    this.takeover_repairer_total_cost = takeover_repairer_total_cost
    this.takeover_client_price = takeover_client_price
    this.takeover_transport_cost = takeover_transport_cost
    this.takeover_additional_cost = takeover_additional_cost
    this.takeover_client_total_cost = takeover_client_total_cost

    this.takeover_product_replacement_name = takeover_product_replacement_name
    this.takeover_product_replacement_boomerang_id = takeover_product_replacement_boomerang_id

    this.takeover_billing_number = takeover_billing_number

    this.breakdown_description = breakdown_description
    this.breakdown_type = breakdown_type
    this.breakdown_type_boomerang_id = breakdown_type_boomerang_id

    this.repairer_estimate_pricing_type = repairer_estimate_pricing_type
    this.initial_pricing_type = initial_pricing_type

    this.package_boomerang_id = package_boomerang_id
    this.package_code = package_code
    this.package_type = package_type
    this.package_client_price = package_client_price
    this.package_repairer_cost_code = package_repairer_cost_code
    this.package_repairer_cost_value = package_repairer_cost_value
    this.package_network_code = package_network_code
    this.package_designation = package_designation
    this.package_frns_billing_code = package_frns_billing_code
    this.package_frns_designation = package_frns_designation
    this.package_discount_rate = package_discount_rate
    this.package_catalog_value = package_catalog_value

    this.packet_weight = packet_weight
    this.packet_length = packet_length
    this.packet_height = packet_height
    this.packet_width = packet_width
    this.packet_battery_voltage = packet_battery_voltage
    this.packet_battery_amperage = packet_battery_amperage
    this.packet_battery_watt_hour = packet_battery_watt_hour
    this.express_check_box = express_check_box

    this.initial_customer_code = initial_customer_code
    this.initial_package_additional_repair_cost = initial_package_additional_repair_cost
    this.initial_package_transport_cost = initial_package_transport_cost
    this.initial_package_total_repair_cost = initial_package_total_repair_cost
    this.initial_package_transport_ref_code = initial_package_transport_ref_code

    this.initial_transporter_modality = initial_transporter_modality
    this.initial_transporter_type = initial_transporter_type
    this.initial_transporter_name = initial_transporter_name
    this.initial_expressist_transporter_id = initial_expressist_transporter_id
    this.initial_expressist_transporter_connexion_id = initial_expressist_transporter_connexion_id
    this.initial_expressist_transporter_connexion_link_id = initial_expressist_transporter_connexion_link_id

    this.tracking_number = tracking_number
    this.with_collect = with_collect

    this.delivery_address_list = delivery_address_list

    this.breakdown_question_list = breakdown_question_list

    this.product_guarantee_list = product_guarantee_list

    this.repairer_estimate = repairer_estimate

    this.updated_at = updated_at
    this.created_at = created_at

    this.business_created_at = business_created_at
    this.finalization_date = finalization_date

    this.repairer_estimate_last_relaunch_date = repairer_estimate_last_relaunch_date
    this.repairer_estimate_last_relaunch_date_day_count = repairer_estimate_last_relaunch_date_day_count

    this.estimate_package_last_relaunch_date = estimate_package_last_relaunch_date
    this.estimate_package_last_relaunch_date_day_count = estimate_package_last_relaunch_date_day_count

    this.business_created_day_count = business_created_day_count
    this.takeover_by_client_date = takeover_by_client_date

    this.deleted_date = deleted_date
    this.deleted_day_count = deleted_day_count

    this.close_date = close_date
    this.close_day_count = close_day_count

    this.leave_and_close_with_reason_date = leave_and_close_with_reason_date
    this.leave_and_close_with_reason_day_count = leave_and_close_with_reason_day_count

    this.guarantee_extension_boomerang_proof = guarantee_extension_boomerang_proof
    this.guarantee_extension_boomerang_end_date = guarantee_extension_boomerang_end_date
    this.guarantee_extension_boomerang_id = guarantee_extension_boomerang_id

    this.initial_erp_repairer_number = initial_erp_repairer_number

    this.with_erp_intern = with_erp_intern
    this.erp_intern_client_id = erp_intern_client_id

    this.prospect_document_list = prospect_document_list
    this.prospect_picture_list = prospect_picture_list
    this.prospect_additional_info = prospect_additional_info
    this.prospect_repairer_email_contact = prospect_repairer_email_contact

    this.prospect_manufacturer_support_number = prospect_manufacturer_support_number
    this.prospect_manufacturer_comment = prospect_manufacturer_comment
    this.prospect_manufacturer_choice = prospect_manufacturer_choice
    this.prospect_manufacturer_attachment_filename = prospect_manufacturer_attachment_filename
    this.prospect_manufacturer_attachment_path = prospect_manufacturer_attachment_path
  }
}
